// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.appform-container .cancel-btn {
  background-color: #FFF;
  border: 1px solid #c5d2c8;
  border-radius: 0.5rem;
  color: #000;
}
.appform-container .cancel-btn:hover {
  background-color: #CEE0F5;
  border: 1px solid #CEE0F5;
  color: #0851A3;
}
.appform-container .submit-btn {
  background-color: #0A4FAE;
  border-radius: 0.5rem;
  color: #fff;
}
.appform-container .max-width-768 {
  max-width: 768px;
}
.appform-container .spinner-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(255, 255, 255, 0.8);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
  pointer-events: all;
}`, "",{"version":3,"sources":["webpack://./../jobportal/src/components/PortalApplicationContent/ApplicationForm/ApplicationForm.scss"],"names":[],"mappings":"AACE;EACE,sBAAA;EACA,yBAAA;EACA,qBAAA;EACA,WAAA;AAAJ;AAGE;EACE,yBAAA;EACA,yBAAA;EACA,cAAA;AADJ;AAIE;EACE,yBAAA;EACA,qBAAA;EACA,WAAA;AAFJ;AAKE;EACE,gBAAA;AAHJ;AAME;EACE,eAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,oCAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;AAJJ","sourcesContent":[".appform-container {\n  .cancel-btn {\n    background-color: #FFF;\n    border: 1px solid #c5d2c8;\n    border-radius: 0.5rem;\n    color: #000;\n  }\n\n  .cancel-btn:hover {\n    background-color: #CEE0F5;\n    border: 1px solid #CEE0F5;\n    color: #0851A3;\n  }\n\n  .submit-btn {\n    background-color: #0A4FAE;\n    border-radius: 0.5rem;\n    color: #fff;\n  }\n\n  .max-width-768 {\n    max-width: 768px;\n  }\n\n  .spinner-overlay {\n    position: fixed;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    background: rgba(255, 255, 255, 0.8);\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    z-index: 9999;\n    pointer-events: all;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
